export const getCardCVV = (cardNumber: string | number): string =>
  cardNumber.toString().substring(12);
